// extracted by mini-css-extract-plugin
module.exports = {"container":"SportSubMenu_container__ppbSi","menu":"SportSubMenu_menu__sc2i9","more":"SportSubMenu_more__gPRJ5","title":"SportSubMenu_title__bdInv"};